import * as ngCore from '@angular/core'
import * as store from '@attain-apps/fe/web/main/lib/store'

import * as me from '../me'

import { getActionsConfig } from './actions'
import { Api } from './api'
import * as effects from './effects'
import { Selectors } from './selectors'
import { State } from './state'

/**
 * Manages file uploads to S3
 */
@ngCore.Injectable({ providedIn: 'root' })
export class Feature extends store.Feature<
  State,
  Selectors,
  ReturnType<typeof getActionsConfig>
> {
  /** @see {@link Api} */
  public readonly api = ngCore.inject(Api)

  constructor() {
    const meFeature = ngCore.inject(me.Feature)
    super({
      actions: getActionsConfig(),
      initialState: State.INITIAL,
      name: 'FileMgmt',
      selectors: () => new Selectors(this, meFeature),
    })

    this.registerEffects(
      effects.loadFinderFilesOnRequest(meFeature),
      effects.loadFinderFilesOnFinderOpen(),
      effects.onUploadRequest(),
      effects.onDownloadRequest(),
      effects.onDownloadSuccess(),
    )
  }
}
